var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardViewBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21811_22971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3994 1.0625H3.02441C2.42768 1.0625 1.85538 1.29955 1.43342 1.72151C1.01147 2.14347 0.774414 2.71576 0.774414 3.3125V15.6875C0.774414 16.2842 1.01147 16.8565 1.43342 17.2785C1.85538 17.7004 2.42768 17.9375 3.02441 17.9375H15.3994C15.9962 17.9375 16.5684 17.7004 16.9904 17.2785C17.4124 16.8565 17.6494 16.2842 17.6494 15.6875V3.3125C17.6494 2.71576 17.4124 2.14347 16.9904 1.72151C16.5684 1.29955 15.9962 1.0625 15.3994 1.0625ZM6.39941 7.25H16.5244V11.1875H6.39941V7.25ZM5.27441 11.1875H1.89941V7.25H5.27441V11.1875ZM1.89941 15.6875V12.3125H5.27441V16.8125H3.02441C2.72605 16.8125 2.4399 16.694 2.22892 16.483C2.01794 16.272 1.89941 15.9859 1.89941 15.6875ZM15.3994 16.8125H6.39941V12.3125H16.5244V15.6875C16.5244 15.9859 16.4059 16.272 16.1949 16.483C15.9839 16.694 15.6978 16.8125 15.3994 16.8125Z",
    fill: "#CED4DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21811_22971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.211914 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardViewBudget);
export default __webpack_public_path__ + "static/media/cardViewBudget.cabad4c472dea896d488f26a8d7c5a7c.svg";
export { ForwardRef as ReactComponent };